import React from "react";
import { useRouteMatch } from "react-router-dom";
import { AppRouter } from "@MASTER";
import { useAuthority } from "@HOOKS";
import DeliveryDetail from "./delivery-detail";
import DeliverySummary from "./delivery-summary";
import DeliverySearch from "./delivery-search";
import DeliveryDistanceReport from "./delivery-distance-report";
import PodDeliveryReport from "./pod-delivery-report";
import DeliveryAreas from "./delivery-areas";

const Deliveries = () => {
  let { path } = useRouteMatch();

  return (
    <div className="app-definitions">
      {useAuthority("REPORTS_DELIVERY_DETAIL") && (
        <AppRouter
          path={`${path}/delivery-detail`}
          title="Gönderi Detay Raporu"
        >
          <DeliveryDetail />
        </AppRouter>
      )}

      {useAuthority("REPORTS_DELIVERY_DETAIL") && (
        <AppRouter
          path={`${path}/delivery-summary`}
          component={DeliverySummary}
          title="Gönderi Özet Raporu"
        />
      )}

      {useAuthority("REPORTS_DELIVERY_DETAIL") && (
        <AppRouter
          path={`${path}/delivery-search`}
          component={DeliverySearch}
          title="Gönderi Sorgulama"
        />
      )}
      {useAuthority("REPORTS_DELIVERY_DETAIL") && (
        <AppRouter
          path={`${path}/pod-delivery-report`}
          title="Tahsilatlı Gönderi Raporu"
        >
          <PodDeliveryReport />
        </AppRouter>
      )}

      {useAuthority("REPORTS_DELIVERY_DISTANCE") && (
        <AppRouter
          path={`${path}/delivery-distance-report`}
          component={DeliveryDistanceReport}
          title="İlden İle Teslimat Süreleri"
        />
      )}
      {useAuthority("REPORTS_DELIVERY_AREAS") && (
        <AppRouter
          path={`${path}/delivery-areas`}
          component={DeliveryAreas}
          title="Detaylı Dağıtım Alanları"
        />
      )}
    </div>
  );
};

export default Deliveries;
